import Head from 'next/head';
import React from 'react';
import { useTranslation } from 'react-i18next';

import Image from '../../components/elements/image/image';
import notFoundImage from './assets/404.png';

import styles from './not-found-view.module.scss';

const NotFoundView: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Head>
        <title>
          {t('page_nested_title', {
            title: t('not_found.page_title'),
          })}
        </title>
      </Head>
      <div className={styles.container}>
        <div className={styles.imageContainer}>
          <Image src={notFoundImage} alt={t('not_found.page_title')} />
        </div>
      </div>
    </>
  );
};

export default NotFoundView;
